import * as React from "react";
import {connect} from "react-redux";
import * as selectors from "../selectors";
import LocationalState from "../LocationalState";
import {RoadSegment} from "../../../../integration/representation/road-segment";
import RoadSegments from "../../../shared-components/map/RoadSegments";
import {
    displayMissingDirectionMessage,
    DisplayMissingDirectionMessage,
    setSelectedRoadSegment,
    SetSelectedRoadSegment
} from "../actions";

interface DispatchProps {
    doSetSelectedRoadSegment: SetSelectedRoadSegment,
    doDisplayMissingDirectionMessage: DisplayMissingDirectionMessage
}

interface StateProps {
    roadSegments: RoadSegment[],
    selectedRoadSegment: RoadSegment,
}

type Props = StateProps & DispatchProps;

const mapStateToProps = (state: LocationalState): StateProps => {
    return {
        roadSegments: selectors.roadSegments(state),
        selectedRoadSegment: selectors.selectedRoadSegment(state),
    };
};

const mapDispatchToProps: DispatchProps = ({
    doSetSelectedRoadSegment: setSelectedRoadSegment,
    doDisplayMissingDirectionMessage: displayMissingDirectionMessage
});

class RoadSegmentLayerComponent extends React.Component<Props, {}> {
    render() {
        return(
            <RoadSegments
                roadSegments={this.props.roadSegments}
                selectedRoadSegment={this.props.selectedRoadSegment}
                doSetSelectedRoadSegment={this.props.doSetSelectedRoadSegment}
                doDisplayMissingDirectionMessage={this.props.doDisplayMissingDirectionMessage}
            />
        );
    }
}

export const RoadSegmentLayer = connect(mapStateToProps, mapDispatchToProps)(RoadSegmentLayerComponent);